import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBankingUserLoginV2Mutation, LoginV3AuthError, } from "generated/generated-models";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import RequestMultiFactorToken from "../../components/RequestMultiFactorToken";
import LoginErrorMessage from "./LoginErrorMessage";
import LoginHeader from "./LoginHeader";
import { Box, Button, Paper } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import { LoadingButton } from "@mui/lab";
import { setSecureStorageToken } from "core/apollo/SecureStoragePluginFunctions";
const EnterMfa = ({ username, password, requiresNewPassword, reset, isUsingGoogleAuth, }) => {
    const navigate = useNavigate();
    const [twoFactorToken, setTwoFactorToken] = useState("");
    const [userLogin, { loading, data, error }] = useBankingUserLoginV2Mutation();
    const handleSubmit = (e) => {
        e.preventDefault();
        if (twoFactorToken === "") {
            return;
        }
        userLogin({
            variables: {
                input: {
                    Password: password,
                    Username: username,
                    TwoFactorToken: twoFactorToken,
                },
            },
            context: { headers: { "X-Interfi-RequestType": "Anonymous" } },
        });
    };
    if (data?.loginV2?.AuthSucceeded) {
        if (data.loginV2.AccessToken) {
            setSecureStorageToken(data.loginV2.AccessToken);
        }
        navigate("/");
    }
    if (data?.loginV2?.AuthError === LoginV3AuthError.Requirepasswordchange) {
        requiresNewPassword(username, password, twoFactorToken);
    }
    return (_jsx("div", { children: _jsx("div", { id: "login-screen", children: _jsxs(Paper, { sx: { p: 10, borderRadius: 3 }, variant: "elevation", elevation: 24, className: "login-screen set-password", children: [_jsx(LoginHeader, { heading: isUsingGoogleAuth
                            ? "Login with 2FA"
                            : "Login with Token", subHeading: isUsingGoogleAuth
                            ? "Confirm your login by entering the authorisation code provided by your preferred one-time password application."
                            : "Confirm your login by entering the security token that you will receive shortly." }), _jsx(LoginErrorMessage, { loginError: error, loginResponse: data, isUsingGoogleAuth: isUsingGoogleAuth }), _jsxs("form", { autoComplete: "off", onSubmit: (e) => handleSubmit(e), className: "prelogin-form", children: [_jsx(Box, { sx: { display: "flex", flexWrap: "wrap" }, children: _jsx(RequestMultiFactorToken, { getToken: setTwoFactorToken, showRequestNewToken: false, isUsingGoogleAuth: isUsingGoogleAuth }) }), _jsxs("div", { className: "form-group button-row", children: [_jsx(Button, { role: "secondary", id: "cancel", sx: { width: 150, p: 1.5, mt: 1, mr: 1 }, variant: "outlined", onClick: reset, disabled: loading, children: "Cancel" }), _jsx(LoadingButton, { type: "submit", id: "submit", sx: { width: 150, p: 0.5, mt: 1 }, endIcon: _jsx(LoginIcon, {}), loading: loading, loadingPosition: "end", variant: "contained", children: "Login" })] })] })] }) }) }));
};
export default EnterMfa;
